export const en = {
	title: 'JourneyNodes',
	language: 'Language',
	connectionStrategy: 'Connection emphasis',
	connectionStrategyRelationFirst: 'Relation-first',
	connectionStrategyBalanced: 'Balanced',
	connectionStrategyLabelFirst: 'Tag-similarity first',
	connectionDisplayMode: 'Line display',
	connectionDisplayModeAll: 'Show all lines',
	connectionDisplayModeTagDerived: 'Only tag auto-lines',
	connectionDisplayModeExplicitOnly: 'Only manual relationship lines',
	connectionDisplayModeTagDerivedFocus: 'Tag lines, fade others on focus',
	gatePrompt: 'Sign in with Google',
	password: 'Google sign-in',
	unlock: 'Unlock',
	startupHeading: 'JourneyNodes',
	startupBody: 'Create clear character relationship maps with less friction, then explore people, events, roles, and context as a living star map.',
	startupPreviewEyebrow: 'Public preview',
	startupUnlockedEyebrow: 'Full mode',
	startupPreviewMode: 'Preview mode: load the Bible and Three Kingdoms templates, or create a blank graph (up to 10 nodes).',
	startupUnlockedMode: 'Unlocked: load full templates, import archives, and create unlimited nodes.',
	startupUnlockPrompt: 'Sign in with an enabled Google account to unlock full mode',
	startupTemplatesTitle: 'Templates',
	startupTemplatesHint: 'Bible and Three Kingdoms are free to preview.',
	startupTemplatePublic: 'Preview',
	startupTemplateUnlocked: 'Unlocked',
	startupActionsTitle: 'Startup actions',
	startupLoadTemplate: 'Load template',
	startupLoadingTemplate: 'Loading template...',
	startupLoadTemplateDescription: 'Load the current sample relationship graph.',
	startupLoadThreeKingdomsTemplate: 'Three Kingdoms template',
	startupLoadThreeKingdomsTemplateDescription: 'Load a public-domain Romance of the Three Kingdoms graph of people, battles, and roles.',
	startupLoadChristianBibleTemplate: 'Holy Bible template',
	startupLoadChristianBibleTemplateDescription: 'Load a Chinese Union Version-inspired graph of the four Gospels and key Old Testament figures.',
	startupLoadJinYongTemplate: 'Jin Yong template',
	startupLoadJinYongTemplateDescription: 'After unlocking, load the Jin Yong character relationship sample graph.',
	startupLoadArchive: 'Load your archive file',
	startupLoadArchiveDescription: 'Pick a .journeynodes file and enter the main view with it.',
	startupBlankProject: 'Blank project',
	startupBlankProjectDescription: 'Create an empty graph and start adding nodes from scratch.',
	startupBlankPreviewProjectDescription: 'Create a blank preview graph with up to 10 added nodes before full mode.',
	startupAbout: 'About',
	startupAboutPanelTitle: 'About',
	startupAboutPanelBody: 'Read creative notes, release updates, and project context on the blog.',
	startupAboutBlog: 'Blog',
	blankProjectTitle: 'Untitled Journey',
	previewNodeLimitReached: 'Preview mode can create up to 10 nodes. For the full experience, contact the original author.',
	invalidPassword: 'This Google account is not enabled for full mode.',
	unableToVerifyPassword: 'Unable to verify Google sign-in right now.',
	googleSignInLoading: 'Loading Google sign-in...',
	googleSignInVerifying: 'Verifying Google account...',
	googleSignInUnavailable: 'Google sign-in is not configured yet. Public preview remains available.',
	googleAccountNotEnabled: 'This Google account is not enabled for full mode, so preview mode remains active.',
	unableToVerifyGoogleSignIn: 'Unable to verify Google sign-in right now. Please try again later.',
	googleAccountPanelLabel: 'Google account status',
	googleSignedInAs: 'Signed in as',
	googleSignOut: 'Sign out of Google',
	googleSignOutDescription: 'Clear this full-mode session',
	search: 'Search nodes',
	searchHint: 'Type a node name to pull up results.',
	searchJump: 'Jump to a matching node.',
	all: 'All',
	human: 'Human',
	project: 'Project',
	occupation: 'Occupation',
	noExact: 'No exact match. Showing close candidates.',
	clear: 'Clear',
	recent: 'recent',
	exact: 'exact',
	nearMatch: 'near match',
	create: 'Create',
	createNode: 'Create node',
	saveNode: 'Save node',
	relationshipPanelTitle: 'Relationship editor',
	relationshipPanelEyebrow: 'Explicit relationship pair',
	relationshipSummaryTitle: 'Explicit relationships',
	manageRelationships: 'Manage relationships',
	viewRelationshipDetails: 'View relationship details',
	noExplicitRelationships: 'No explicit relationships yet.',
	relationshipTargetTypeFilter: 'Target type',
	relationshipTargetNode: 'Relationship target',
	relationshipTargetPlaceholder: 'Choose a second node',
	relationshipPanelEmptyState: 'Choose another node to start a dual-direction relationship pair.',
	relationshipPanelExistingPair: 'This pair already exists. Adjust the labels and save to update it.',
	relationshipPanelCreateGuidance: 'Add one or more labels in either direction to create this pair.',
	relationshipReadonlyNotice: 'Read-only graphs can view relationships, but cannot create, edit, or delete them.',
	relationshipSummaryOverflowHint: 'The line summary is compacted here. Open details to read every label.',
	relationshipMixedSummaryHint: 'This pair also has auto-derived connection reasons.',
	relationshipDerivedReasonsTitle: 'Auto-derived connection reasons',
	relationshipDirectionNoLabels: 'No label has been added in this direction.',
	relationshipBlockedTitle: 'Relationship update blocked',
	relationshipBlockedHint: 'Fix the issues below before this pair can be saved.',
	relationshipSaveAction: 'Save relationship',
	relationshipDeleteAction: 'Remove this relationship',
	relationshipValidationEmpty: 'Add at least one label before saving.',
	relationshipValidationDuplicate: 'Each direction must avoid duplicate labels.',
	relationshipValidationMissingTarget: 'Choose a valid existing target node before saving.',
	relationshipValidationSelf: 'A node cannot create an explicit relationship with itself.',
	relationshipDetailTitle: 'Relationship details',
	relationshipDetailEyebrow: 'Relationship detail',
	relationshipDetailEmpty: 'Choose a relationship pair from the summary list or editor first.',
	relationshipDetailEditAction: 'Edit this relationship',
	edit: 'Edit',
	editFocusedNode: 'Edit focused node',
	editAllFields: 'Edit all fields',
	deleteNode: 'Delete',
	deleteNodeConfirmTitle: 'Delete node',
	deleteNodeConfirmPrompt: 'Delete node "{name}"? This action cannot be undone.',
	deleteNodeConfirmAction: 'Confirm delete',
	cancel: 'Cancel',
	close: 'Close',
	archiveExport: 'Export .journeynodes',
	archiveExportDialogTitle: 'Export archive',
	archiveExportFileName: 'File name',
	archiveExportTitle: 'Archive title',
	archiveExportSyncTitle: 'Also update the current graph title',
	archiveExportSaveMode: 'Save mode',
	archiveSaveModePicker: 'Choose a save location',
	archiveSaveModeDownload: 'Download to the browser default location',
	archiveExportWarningsPreview: 'Warnings before export: {warnings}',
	archiveSavePickerUnavailable: 'This browser cannot pick a save location here, so the archive will download to the default location.',
	archiveExportConfirm: 'Export archive',
	archiveExporting: 'Exporting archive...',
	archiveImport: 'Import .journeynodes',
	archiveImporting: 'Importing archive...',
	archiveToolbarHint: 'Export keeps the current node layout. Import replaces the current graph in one step.',
	archiveLockedContactAuthor: 'Export requires full mode. Sign in with an enabled Google account.',
	archiveImportConfirmTitle: 'Replace current graph',
	archiveImportReplacePrompt: 'The current graph "{current}" will be replaced by archive "{next}". Continue?',
	archiveImportReplace: 'Replace current graph',
	archiveImportWarningsPreview: 'Warnings before import: {warnings}',
	archiveSpatialStatusLabel: '3D layout status',
	archiveSpatialRoundTripStatus: '3D layout is ready to round-trip.',
	archiveSpatialFallbackStatus: 'This archive will auto-layer its 3D depth before it opens.',
	archiveSpatialWarningsListTitle: '3D layout warnings',
	archiveLoadedSample: 'Loaded sample archive: {title}. Import another .journeynodes file to replace it.',
	archiveExported: 'Exported {title}.',
	archiveExportedWarnings: 'Exported {title} with warnings: {warnings}',
	archiveImported: 'Imported {title}.',
	archiveImportedWarnings: 'Imported {title} with warnings: {warnings}',
	archiveStatusSpatialRoundTripReady: '3D layout is ready to round-trip.',
	archiveStatusSpatialFallbackApplied: '3D layout fallback will be applied.',
	archiveSampleLoadFailed: 'Unable to load the default sample archive. {detail}',
	archiveImportFailed: 'Unable to import this .journeynodes file. {detail}',
	archiveImportFailedTitle: 'Archive import failed',
	archiveImportFailureLayoutNote: 'The current graph and its saved 3D layout stay unchanged.',
	'workspace.mode.group': 'Workspace mode',
	'workspace.mode.current': 'Current workspace',
	'workspace.mode.controls': 'Workspace controls',
	'workspace.mode.controlsShow': 'Open controls',
	'workspace.mode.controlsHide': 'Hide controls',
	'workspace.mode.2d': '2D',
	'workspace.mode.3d': '3D',
	'workspace.mode.outline': 'Outline',
	'workspace.mode.2dLabel': '2D graph',
	'workspace.mode.3dLabel': '3D graph scene',
	'workspace.mode.outlineLabel': 'Outline workspace',
	'workspace.mode.3dHint': 'Stay in the same graph and move through it with a more spatial camera.',
	'workspace.mode.3dTools': '3D tools',
	'workspace.mode.3dNodeList': '3D node list',
	'workspace.mode.3dGamepad': '3D navigation controls',
	'workspace.mode.3dNavigate': 'Navigate scene',
	'workspace.mode.3dMoveNode': 'Move node',
	'workspace.mode.3dMoveNodeReadonly': 'Read-only graphs cannot move nodes.',
	'workspace.mode.3dNavigateHint': 'Hold middle mouse or Shift-drag to orbit. Use the wheel to zoom.',
	'workspace.mode.3dFlyHint': 'W/A/S/D to fly. Q/E to rise or descend. Hold Shift to move faster.',
	'workspace.mode.3dLabels': 'People names',
	'workspace.mode.3dLabelsHint': 'Each type can toggle its names independently, and labels scale with camera distance.',
	'workspace.mode.3dLabelsVisible': 'People names shown',
	'workspace.mode.3dLabelsHidden': 'People names hidden',
	'workspace.mode.3dLabelTypeVisibility': '3D label type visibility',
	'workspace.mode.3dLabelTypesVisible': '{count} label types enabled',
	'workspace.mode.3dColor': 'Color',
	'workspace.mode.3dBrightness': 'Brightness',
	'workspace.mode.3dBrightnessValue': 'Brightness {value}',
	'workspace.mode.3dColorForType': '{name} color',
	'workspace.mode.3dBrightnessForType': '{name} brightness',
	'workspace.mode.3dMoveNodeHint': 'Drag an orb to reposition it. Release to commit. Press Esc to cancel.',
	'workspace.mode.3dPlacementActive': 'Placement preview',
	'workspace.mode.3dPlacementNode': 'Moving {name}',
	'workspace.mode.3dBeginFocusedPlacement': 'Start moving {name}',
	'workspace.mode.3dPlacementDepth': 'Depth {depth}',
	'workspace.mode.3dPlacementOffset': 'Offset X {x} / Y {y} / Z {z}',
	'workspace.mode.3dPanCluster': 'Pan',
	'workspace.mode.3dOrbitCluster': 'Orbit',
	'workspace.mode.3dZoomCluster': 'Zoom',
	'workspace.mode.3dPanLeft': 'Pan 3D view left',
	'workspace.mode.3dPanRight': 'Pan 3D view right',
	'workspace.mode.3dPanUp': 'Pan 3D view up',
	'workspace.mode.3dPanDown': 'Pan 3D view down',
	'workspace.mode.3dRotateLeft': 'Rotate view left',
	'workspace.mode.3dRotateRight': 'Rotate view right',
	'workspace.mode.3dRotateUp': 'Tilt view upward',
	'workspace.mode.3dRotateDown': 'Tilt view downward',
	'workspace.mode.3dZoomIn': 'Zoom 3D view in',
	'workspace.mode.3dZoomOut': 'Zoom 3D view out',
	'workspace.mode.3dDepthLegend': 'Near, mid, and far depth labels stay readable while you navigate.',
	'workspace.mode.3dVisibleCount': '{count} nodes visible',
	'workspace.mode.3dOverviewHint': 'Overview recenters the visible graph without clearing your current workspace context.',
	'workspace.appearance.eyebrow': 'Appearance',
	'workspace.appearance.title': 'Node appearance',
	'workspace.appearance.hint': 'Adjust label visibility, color, and brightness per type; 2D and 3D share the same settings.',
	'workspace.appearance.typeVisibility': 'Node label type visibility',
	'workspace.appearance.color': 'Color',
	'workspace.appearance.brightness': 'Brightness',
	'workspace.appearance.brightnessValue': 'Brightness {value}',
	'workspace.appearance.colorForType': '{name} color',
	'workspace.appearance.brightnessForType': '{name} brightness',
	'workspace.mode.3dDepthNear': 'Near field',
	'workspace.mode.3dDepthMid': 'Mid field',
	'workspace.mode.3dDepthFar': 'Far field',
	'workspace.outline.title': 'Outline workspace',
	'workspace.outline.searchPlaceholder': 'Search nodes, summaries, or relationship previews',
	'workspace.outline.count': 'Visible nodes',
	'workspace.outline.sort': 'Sort',
	'workspace.outline.sortDirection': 'Direction',
	'workspace.outline.sortAsc': 'Ascending',
	'workspace.outline.sortDesc': 'Descending',
	'workspace.outline.filter': 'Outline filter',
	'workspace.outline.groupByType': 'Group by type',
	'workspace.outline.ungrouped': 'Ungrouped',
	'workspace.outline.returnTo2d': 'Return to 2D graph',
	'workspace.outline.returnTo3d': 'Return to 3D graph',
	'workspace.outline.allResults': 'All results',
	'workspace.outline.type': 'Type',
	'workspace.outline.connections': 'Connections',
	'workspace.outline.actions': 'Actions',
	'workspace.outline.locate': 'Locate in graph',
	'workspace.outline.inlineEdit': 'Quick edit',
	'workspace.outline.inlineEditNode': 'Quick edit {name}',
	'workspace.outline.inlineSave': 'Save row edits',
	'workspace.outline.inlineCancel': 'Cancel row edits',
	'workspace.outline.fullEditor': 'Full editor',
	'workspace.outline.lockedByEditor': 'Locked by the full editor.',
	'workspace.outline.emptyTitle': 'No nodes match this workspace yet',
	'workspace.outline.emptyBody': 'Adjust the local filter or search query, or create a new node directly from the outline.',
	'workspace.outline.workflowHint': 'AI settings, AI workspace, and archive import or export stay available in the HUD while the outline is open.',
	'workspace.outline.locateHint': 'Locate returns to the last graph mode and keeps the selected node in focus.',
	topConnections: 'Top connections',
	returnToFullMap: 'Return to full map',
	completeNodeDetails: 'Complete node details',
	coreFields: 'Core fields',
	humanRelations: 'Human relations',
	projectRelations: 'Project relations',
	occupationRelations: 'Occupation relations',
	visualMetadata: 'Visual metadata',
	systemMetadata: 'System metadata',
	notes: 'Notes',
	customFields: 'Custom fields',
	noNotes: 'No notes.',
	noCustomFields: 'No custom fields.',
	displayName: 'Display name',
	summaryLabel: 'Summary',
	referenceHumanPlaceholder: 'h2 or Grace Hopper',
	referenceProjectPlaceholder: 'p1 or Analytical Engine',
	referenceOccupationPlaceholder: 'o1 or Mathematician',
	tags: 'Tags',
	imageSource: 'Image source',
	presetAvatarId: 'Preset avatar id',
	uploadedImageAssetId: 'Uploaded image asset id',
	nodeId: 'Node id',
	createdAt: 'Created at',
	updatedAt: 'Updated at',
	localTimeLabel: 'Local time',
	originTimeZoneLabel: 'origin',
	timeZoneAsiaTaipei: 'Taipei time',
	occupationIds: 'Occupation ids',
	projectIds: 'Project ids',
	relatedHumanIds: 'Related human ids',
	participantHumanIds: 'Participant human ids',
	relatedOccupationIds: 'Related occupation ids',
	relatedProjectIds: 'Related project ids',
	typicalProjectIds: 'Typical project ids',
	noSummaryYet: 'No summary yet.',
	none: 'None',
	fallbackPortraitActive: 'Fallback portrait active',
	uploadedPortraitActive: 'Uploaded portrait linked to this node',
	presetPortraitActive: 'Preset character portrait active',
	fieldLabel: 'Field label',
	fieldValue: 'Field value',
	valueType: 'Value type',
	displayOrder: 'Display order',
	addField: 'Add field',
	removeField: 'Remove field',
	presetAvatarCatalog: 'Preset avatar catalog',
	imageSourceFallback: 'Fallback',
	imageSourcePresetAvatar: 'Preset avatar',
	imageSourceUpload: 'Uploaded asset',
	readOnlyViewer: 'Read-only viewer: only the owner can edit this graph.',
	'settings.workspace.title': 'AI settings',
	'settings.workspace.nav': 'Settings navigation',
	'settings.workspace.graphScoped': 'These settings belong to the current graph archive.',
	'settings.deidentification.title': 'De-identification',
	'settings.deidentification.description': 'Protect Human names first, then adjust field text, tags, and manual rules.',
	'settings.deidentification.enabled': 'Enable graph-scoped AI de-identification',
	'settings.deidentification.candidates': 'De-identification candidates',
	'settings.deidentification.showHumans': 'Focus Human candidates',
	'settings.deidentification.showAll': 'Show all candidates',
	'settings.deidentification.replacementPlaceholder': 'Replacement value',
	'settings.deidentification.manualRules': 'Manual rules',
	'settings.deidentification.manualOriginal': 'Original keyword',
	'settings.deidentification.manualReplacement': 'Replacement text',
	'settings.deidentification.addRule': 'Add rule',
	'settings.deidentification.removeRule': 'Remove rule',
	'settings.deidentification.manualRuleInvalid': 'Original and replacement values are both required.',
	'settings.deidentification.preview': 'Local preview',
	'settings.deidentification.previewInput': 'Preview input',
	'settings.deidentification.previewPlaceholder': 'Paste sample text here to preview masking and restore behavior.',
	'settings.deidentification.runPreview': 'Run preview',
	'settings.deidentification.maskedResult': 'Masked result',
	'settings.deidentification.restoredResult': 'Restored result',
	'settings.deidentification.conflictWarning': 'Some rules are blocked because their replacements are ambiguous to restore.',
	'settings.deidentification.readonly': 'Read-only mode: view settings only.',
	'settings.deidentification.promptContract': 'Prompt contract and example response',
	'settings.deidentification.createNodePromptContract': 'Create-node prompt contract and example JSON',
	'settings.deidentification.createNodeSystemPrompt': 'Create-node system prompt',
	'settings.deidentification.createNodeExampleJson': 'Create-node example JSON',
	'settings.deidentification.createNodeExampleInvalid': 'The create-node example JSON must be a valid single-node object.',
	'settings.deidentification.bucket.human': 'Human',
	'settings.deidentification.bucket.field': 'Field',
	'settings.deidentification.bucket.tag': 'Tag',
	'settings.future.title': 'Future settings',
	'settings.future.description': 'More graph-scoped settings will appear here later.',
	'workspace.aiAssist.title': 'AI workspace',
	'workspace.aiAssist.description': 'Prepare raw JSON, masked JSON, a copy-ready prompt, and validate pasted AI responses.',
	'workspace.aiAssist.pageNav': 'AI workspace subpages',
	'workspace.aiAssist.readonly': 'Read-only mode keeps saved settings locked, but you can still inspect the workspace.',
	'workspace.aiAssist.stale': 'The current workspace is stale. Rebuild the bundle and prompt before using it.',
	'workspace.aiAssist.selectedNodePage': 'Edit node',
	'workspace.aiAssist.selectedNodePageHint': 'Choose existing nodes, build bundles, and import AI edits.',
	'workspace.aiAssist.createNodePage': 'Create node',
	'workspace.aiAssist.createNodePageHint': 'Create a new node from a natural-language request and JSON.',
	'workspace.aiAssist.selectedNodes': 'Selected nodes',
	'workspace.aiAssist.noneSelected': 'No nodes selected yet.',
	'workspace.aiAssist.selectionHint': 'When you check nodes, the raw JSON, masked JSON, and prompt preview update automatically.',
	'workspace.aiAssist.searchNodes': 'Search nodes',
	'workspace.aiAssist.nodeType': 'Node type',
	'workspace.aiAssist.filterAll': 'All',
	'workspace.aiAssist.noMatchingNodes': 'No nodes match the current search and filter.',
	'workspace.aiAssist.buildSource': 'Build raw JSON',
	'workspace.aiAssist.buildMasked': 'Apply de-identification',
	'workspace.aiAssist.buildPrompt': 'Render prompt preview',
	'workspace.aiAssist.rawJson': 'Raw JSON bundle',
	'workspace.aiAssist.maskedJson': 'Masked JSON bundle',
	'workspace.aiAssist.promptPreview': 'Prompt preview',
	'workspace.aiAssist.userPrompt': 'User prompt',
	'workspace.aiAssist.userPromptPlaceholder': 'For example: fill in missing background, project context, and relationships from the selected nodes.',
	'workspace.aiAssist.createNodeSection': 'Create node',
	'workspace.aiAssist.createNodeHint': 'Describe the new node in natural language. This flow renders the single-node prompt from the AI settings contract, then validates the pasted JSON before creating the node.',
	'workspace.aiAssist.createNodeRequest': 'Create-node request',
	'workspace.aiAssist.createNodeRequestPlaceholder': 'For example: create a new project node with key relationships and essential fields.',
	'workspace.aiAssist.createNodePromptPreview': 'Create-node prompt preview',
	'workspace.aiAssist.createNodeExample': 'Create-node example JSON',
	'workspace.aiAssist.createNodeJson': 'Create-node JSON',
	'workspace.aiAssist.importActions': 'Import actions',
	'workspace.aiAssist.importOperations': 'Import AI changes',
	'workspace.aiAssist.createNodeAction': 'Create node',
	'workspace.aiAssist.createNodeResponseValid': 'The create-node JSON matches the contract.',
	'workspace.aiAssist.copyCreateNodePrompt': 'Copy create-node prompt',
	'workspace.aiAssist.expandRawJson': 'Expand raw JSON',
	'workspace.aiAssist.expandMaskedJson': 'Expand masked JSON',
	'workspace.aiAssist.expandPromptPreview': 'Expand prompt preview',
	'workspace.aiAssist.diff': 'Replacement diff',
	'workspace.aiAssist.responseDraft': 'Pasted AI response',
	'workspace.aiAssist.responseValid': 'The AI response matches the operations[] contract.',
	'workspace.aiAssist.systemPrompt': 'System prompt',
	'workspace.aiAssist.exampleResponse': 'Example response JSON',
	'workspace.aiAssist.copyRawJson': 'Copy raw JSON',
	'workspace.aiAssist.copyMaskedJson': 'Copy masked JSON',
	'workspace.aiAssist.copyPromptPreview': 'Copy prompt preview',
	'workspace.aiAssist.copied': 'Copied the full content.',
	'workspace.aiAssist.copiedShort': 'Copied',
	'archive.aiConfig.loaded': 'AI settings were restored from the archive.',
	'archive.aiConfig.legacyFallback': 'This archive did not include AI settings, so safe defaults were initialized.',
	'archive.aiConfig.invalid': 'Some AI settings could not be restored and were replaced with safe defaults.',
	'regression.aiSettings.readonly': 'Readonly view only',
	validationDisplayNameRequired: 'Display name is required.',
	validationCustomFieldLabelRequired: 'Custom field label is required.',
	validationCustomFieldIdsUnique: 'Custom field ids must be unique.',
	validationTagsInvalid: 'Tags can only contain letters, numbers, and spaces. Use commas to separate multiple tags.',
	validationProjectSelfReference: 'Project cannot reference itself.',
	hiddenByFilter: 'hidden by filter'
} as const;
